import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import { subscribeToast } from "../utils/toastEmitter";

const SEVERITY_COLORS = {
  success: "#065F46",
  error: "#EA001B",
  warning: "#f59e0b",
  info: "#362B24",
};

let _id = 0;

function SlideDownTransition(props) {
  return <Slide {...props} direction="down" />;
}

export default function MuiToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    return subscribeToast(({ type, message }) => {
      const id = ++_id;
      const severity = type === "warn" ? "warning" : type;

      setToasts((prev) => [
        ...prev.slice(-4),
        { id, severity, message },
      ]);

      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 4000);
    });
  }, []);

  const dismiss = (id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  return (
    <>
      {toasts.map((t, i) => (
        <Snackbar
          key={t.id}
          open
          TransitionComponent={SlideDownTransition}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          sx={{
            top: `${i * 68 + 16}px !important`,
          }}
        >
          <Alert
            severity={t.severity}
            onClose={() => dismiss(t.id)}
            sx={{
              fontFamily: "Heebo",
              fontWeight: 500,
              bgcolor:
                SEVERITY_COLORS[t.severity] || SEVERITY_COLORS.info,
              color: "#fff",
              borderRadius: "12px",
              boxShadow: "1px 2px 30px 0px rgba(0,0,0,0.14)",
              minWidth: 280,

              "& .MuiAlert-icon": {
                color: "#fff",
              },

              "& .MuiAlert-action .MuiIconButton-root": {
                color: "#fff",
              },
            }}
          >
            {t.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
}